import "@mui/material/styles";
import type { BreakpointsOptions } from "@mui/material/styles";

// Extend the Breakpoint interface to include xxl and xxxl
declare module "@mui/material/styles" {
  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
    xxl: true; // Custom XXL breakpoint
    fhd: true; // Custom XXXL breakpoint
  }
}

export const breakpoints: BreakpointsOptions = {
  values: {
    xs: 0,
    sm: 568, // tablet view
    md: 768,
    lg: 1024,
    xl: 1280,
    xxl: 1440, // Custom XXL
    fhd: 1800, // Custom XXXL
  },
};
